module.exports = __webpack_public_path__ + "f9f2acbf7746362ebee7218538411a36.svg";